solumaxSms
	.controller('IndexController', function() {

		var vm = this
	})